import api from './api'

// User types
export interface User {
  username: string
  email: string
  status: string
  enabled: boolean
  createdAt: string
  groups: string[]
  sub?: string
}

export interface CreateUserRequest {
  email: string
  temporaryPassword?: string
}

export interface CreateUserResponse {
  username: string
  message: string
}

export interface DeleteUserResponse {
  message: string
  deletedFilesCount: number
}

// Admin operations
export async function listUsers(): Promise<User[]> {
  const response = await api.get<{ users: User[] }>('/admin/users')
  return response.data.users
}

export async function createUser(data: CreateUserRequest): Promise<CreateUserResponse> {
  const response = await api.post<CreateUserResponse>('/admin/users', data)
  return response.data
}

export async function deleteUser(username: string): Promise<DeleteUserResponse> {
  const response = await api.delete<DeleteUserResponse>(
    `/admin/users/${encodeURIComponent(username)}`
  )
  return response.data
}

export async function resetUserPassword(username: string): Promise<{ message: string }> {
  const response = await api.post<{ message: string }>(
    `/admin/users/${encodeURIComponent(username)}/reset-password`
  )
  return response.data
}
